var BASE_USER_PROFILE_KEY = 'userProfile';
var MINDSET_AGENT_KEY = 'mindsetAgent';
var userProfileKeys = {
  userProfile: [BASE_USER_PROFILE_KEY],
  mindsetAgent: [MINDSET_AGENT_KEY]
};
export default userProfileKeys;